module.exports = __webpack_public_path__ + "static/media/29ADMSPC11.522f8b86.jpg";